import React from 'react';

const uuidv4 = require('uuid/v4');

class PackageEditorWorkspace extends React.Component {
    state = { }

    constructor(props) {
        super(props);
        this.workspaceSvg = React.createRef();
    }

    handleMouseDown = (e) => {
        let { insertMode } = this.props;
        //Find start position of drag based on touch/mouse coordinates.
        const startX = typeof e.clientX === 'undefined' ? e.changedTouches[0].clientX : e.clientX;
        const startY = typeof e.clientY === 'undefined' ? e.changedTouches[0].clientY : e.clientY;

        if (insertMode !== null) {
            if (this.workspaceSvg.current === e.target) {
                const { left, top } = e.target.getBoundingClientRect();
                this.setState({ action: 'insert', startX, startY, left, top, drawId: uuidv4() });
            };
        } else {
            this.setState({ startX, startY });
        }
    };

    handleMouseMove = (e) => {
        const { insertMode, onUpdateObject, matrix, scale } = this.props;
        const { startX, startY, top, left, drawId, action } = this.state;

        if (action === null || action === undefined) { return; }

        //Get the new x and y coordinates
        const x = typeof e.clientX === 'undefined' ? e.changedTouches[0].clientX : e.clientX;
        const y = typeof e.clientY === 'undefined' ? e.changedTouches[0].clientY : e.clientY;

        //Take the delta where we are minus where we came from.
        const dx = x - startX;
        const dy = y - startY;

        switch (insertMode) {
            case 'rectangle':
            case 'circle':
                let { obj } = this.state;
                if (obj === null || obj === undefined) {
                    obj = {
                        x: (x - left - matrix[4]) / scale, 
                        y: (y - top - matrix[5]) / scale, 
                        w: 0, 
                        h: 0, 
                        id: drawId
                    }
                }
                obj.w += dx / scale;
                obj.h += dy / scale;
                // if (obj.w < 0 || obj.h < 0) {
                //     let index = objects.findIndex(x => x.id === drawId);
                //     if (index !== -1) {
                //         objects.splice(index, 1);
                //     }
                // }
                this.setState({ obj: obj, manual: true });
                onUpdateObject(obj);
                break;
            default:
                break;
        }

        //Update the new startX and startY position
        //because a drag is likely a continuous movement
        this.setState({ startX: x, startY: y, drawId });
    };

    handleMouseUp = (e) => {
        const { insertMode, matrix, scale, onUpdateObject, selectedQueries, etlPackageId } = this.props;
        const { startX, startY, top, left, drawId, manual, action } = this.state;

        if (action === null || action === undefined) { return; }
        switch (insertMode) {
            case 'query':
                let newQuery = {
                    id: drawId, 
                    etlPackageId: etlPackageId,
                    x: (startX - 13 - left - matrix[4]) / scale, 
                    y: (startY - 13 - top - matrix[5]) / scale,
                    icon: 'dataload', 
                    step: 1, 
                    parent_ids: [],
                    columns: [] 
                }

                if (selectedQueries.length > 0) {
                    newQuery.icon = (selectedQueries.length > 1) ? 'datajoin' : 'default';
                    // newQuery.step += Math.max(...selectedQueries.map(x => x.step));
                    newQuery.parent_ids = [...selectedQueries.map(x => x.id)];
                }

                if(newQuery.icon === 'dataload') {
                    newQuery.settings = {
                        name: '', 
                        // connectionEndpointId: '', 
                        // tableIsQuery: false, 
                        tableId: '',
                        compressed: false,
                        manifest: false,
                        escapeDelimiter: false,
                        csvFile: false,
                        delimiter: '',
                        ignoreHeaderRows: '',
                        copyOnly: false,
                        copyFormatRegex: ''
                    };
                } else if (newQuery.icon === 'datajoin') {
                    newQuery.settings = {
                        name: ''
                    };
                }

                this.props.onCreateQuery(newQuery);
                break;
            case 'rectangle':
            case 'circle':
                if (manual === null || manual === undefined) {
                    onUpdateObject({
                        x: (startX - left - matrix[4]) / scale, 
                        y: (startY - top - matrix[5]) / scale, 
                        w: 50 / scale, 
                        h: 50 / scale, 
                        id: drawId
                    });
                }
                break;
            default:
                break;
        }
        this.setState({ action: null, drawId: null, obj: null });
        this.props.onCallback({ insertMode: null });
    };

    handleMouseWheel = (e) => {
        if (e.ctrlKey) {
            e.preventDefault();
            if (e.deltaY < 0) { this.zoom(1.25); }
            else { this.zoom(0.8); }
        }
        if (e.shiftKey) {
            e.preventDefault();
            if (e.deltaY < 0) { this.pan(0, 50); }
            else { this.pan(0, -50); }
        }
        if (e.altKey) {
            e.preventDefault();
            if (e.deltaY < 0) { this.pan(50, 0); }
            else { this.pan(-50, 0); }
        }
    };

    pan = (dx, dy) => {
        const { matrix, onPanZoom, scale } = this.props;
        matrix[4] += dx;
        matrix[5] += dy;
        onPanZoom({ matrix: matrix, scale: scale });
    };

    zoom = (scaleFactor) => {
        const { matrix, scale, onPanZoom } = this.props;
        const { scrollWidth, scrollHeight } = this.workspaceSvg.current
        for (let i = 0; i < matrix.length; i++) { matrix[i] *= scaleFactor; }
        matrix[4] += (1 - scaleFactor) * scrollWidth / 2;
        matrix[5] += (1 - scaleFactor) * scrollHeight / 2;
        onPanZoom({ matrix: matrix, scale: scale * scaleFactor });
    };

    render() {
        const { matrix, insertMode } = this.props;
        return (
            <div className="package-editor-workspace">
                <svg height="100%" ref={this.workspaceSvg} style={{ cursor: insertMode === null ? 'default' : 'crosshair' }}
                    onWheel={this.handleMouseWheel} onMouseDown={this.handleMouseDown} onMouseMove={this.handleMouseMove} onMouseUp={this.handleMouseUp}>

                    <circle cx="50" cy="50" r="42" strokeWidth="0" fill="white" opacity="0.75" />
                    <path onClick={() => { this.pan(0, 50) }} d="M50 10 l12 20 a40,70 0 0,0 -24,0z" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />
                    <path onClick={() => { this.pan(50, 0) }} d="M10 50 l20 -12 a70,40 0 0,0 0,24z" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />
                    <path onClick={() => { this.pan(0, -50) }} d="M50 90 l12 -20 a40,70 0 0,1 -24,0z" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />
                    <path onClick={() => { this.pan(-50, 0) }} d="M90 50 l-20 -12 a70,40 0 0,1 0,24z" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />

                    <circle cx="50" cy="50" r="20" fill="#fff" stroke="#26a69a" strokeWidth="1.5" />
                    <circle onClick={() => { this.zoom(1.25) }} cx="50" cy="59" r="8" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />
                    <circle onClick={() => { this.zoom(0.8) }} cx="50" cy="41" r="8" fill="#26a69a" stroke="#26a69a" strokeMiterlimit="6" strokeLinecap="round" />

                    <rect x="46" y="39.5" width="8" height="3" fill="#fff" pointerEvents="none" />
                    <rect x="46" y="57.5" width="8" height="3" fill="#fff" pointerEvents="none" />
                    <rect x="48.5" y="55" width="3" height="8" fill="#fff" pointerEvents="none" />

                    <g id="element-container" transform={`matrix(${matrix.join(' ')})`}>
                        {this.props.children}
                    </g>
                </svg>
            </div>
        )
    }
}
export default PackageEditorWorkspace;


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageEditorWorkspace.js